import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";
const urlProd = process.env.REACT_APP_URL_DIR + "Compra";

export function GetCompras() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Compra"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export function GetComprasIns() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Compra"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}
